import { Button } from '../button'

export default function ConfirmCancel({ onBack, onCancel }) {
  return (
    <div className='confirmCancel flex flexDirectionColumn alignCenter'>
      <h2>Cancel Offer</h2>
      <p className='description'>You are about to Cancel offer from this user</p>
      <p className='note'>You won't be able to receive or send offers with this user.</p>
      <div className='buttonsContainer flex justifyCenter'>
        <Button color='secondary' onClick={onBack}>
          Back
        </Button>
        <Button onClick={onCancel}>Accept</Button>
      </div>

      <style jsx>{`
        .confirmCancel {
          justify-content: center;
          width: 100%;
          height: 100%;
        }

        h2 {
          font-size: 3.2rem;
        }

        p {
          text-align: center;
          font-size: 1.6rem;
        }

        .description {
          margin: 1.26rem 0 2.3rem;

          span {
            color: var(--primary-color);
          }
        }

        .note {
          color: var(--secondary-text-color);
          font-weight: 700;
        }

        .buttonsContainer {
          max-width: 39.8rem;
          width: 100%;
          margin: 2rem 0 0;

          :global(button) {
            width: 19.1rem;
            margin: 0 0.8rem;
          }
        }

        @media (max-width: 1024px) {
          .confirmCancel {
            justify-content: flex-start;
          }

          h2 {
            margin-top: 1.5rem;
            font-size: 1.8rem;
          }

          p {
            font-size: 1.4rem;
          }

          .description {
            margin: 0.5rem 0 1rem;
          }

          .buttonsContainer {
            position: fixed;
            left: 0;
            bottom: 2.1rem;
            z-index: 1;
            width: 100%;
            margin: 0;
            padding: 0 1.3rem;

            :global(button) {
              width: 100%;
            }
          }
        }
      `}</style>
    </div>
  )
}
